module.exports = __webpack_public_path__ + "static/jfj-a6b3db9410e5b09c8ee60159518278ae.png";